module.exports = new __parcel__URL__("chemical-sm.dc592547.jpg").toString();